<template>
  <div class="blc-inf-geral fundo">
    <div class="blc-item c-tabela px-4 py-5">
      <div class="row">
        <div class="col-md-6 col-12">
          <h2>List line-up <i class="fa fa-spinner fa-spin" v-if="loading"></i></h2>
          <p>Manage and track vessel operations</p>
        </div>
        <div class="text-right col">
          <button class="submit-vermelho" @click="$emit('clear')">
            Clear Filters <img src="/img/icon-filter.png" />
          </button>
          <button class="submit-vermelho ml-3" @click="$emit('exportAll')">
            Export All
          </button>
          <button v-if="!$root.isClient" class="submit" @click="$emit('new')">
            New lineup +
          </button>
        </div>
      </div>

      <div class="mt-0 row align-items-center pesquisa_dashboard">
        <div class="col-lg-6 mt-3">
          <multiple-select
            multiple
            label="Ports"
            placeholder="Select the ports"
            :options="options.portos"
            optionsValue="name"
            optionsKey="id"
            v-model="value.porto_id"
            :disabled="loading"
          />
        </div>
        <div class="col-lg-6 mt-3">
          <multiple-select
            label="Commodities"
            placeholder="Select the commodities"
            :options="options.cargas"
            optionsValue="name"
            optionsKey="id"
            v-model="value.carga_tipo_id"
            inputClasses="multiselect_destaque input"
            :disabled="loading"
          />
        </div>
        <div class="col-lg-6 mt-3">
          <multiple-select
            multiple
            label="Status"
            placeholder="Select the status"
            :options="statusOptions"
            optionsValue="name"
            optionsKey="name"
            v-model="value.status"
            :disabled="loading"
          />
        </div>
        <div class="col-lg-3 mt-3">
          <multiple-select
            multiple
            label="Charterers"
            placeholder="Select the charterers"
            :options="options.afretadores"
            optionsValue="name"
            v-model="value.afretador_id"
            :disabled="loading"
          />
        </div>
        <div class="col-lg-3 mt-3">
          <multiple-select
            multiple
            label="Disport"
            placeholder="select the destination port"
            :options="options.lineupPortos"
            optionsValue="port_name"
            v-model="value.destination_port"
            :disabled="loading"
          />
        </div>
        <div class="col-lg-6 mt-3" v-if="!$root.isClient">
          <multiple-select
            multiple
            label="Vessels"
            placeholder="search the vessel"
            optionsKey="id"
            optionsValue="name_with_imo"
            :options="options.navios"
            :disabled="loading"
            v-model="value.navio_id"
          />
        </div>
        <div class="col-lg-6 mt-3" v-if="!$root.isClient">
          <multiple-select
            multiple
            label="Naabsa vessels"
            placeholder="select naabsa vessels"
            optionsKey="name"
            :options="clientTypes"
            :disabled="loading"
            v-model="value.client_type"
          />
        </div>
        <div class="col-md-6 col-lg-4 mt-3">
          <base-input
            type="date"
            label="Start period"
            input-classes="form-control-alternative"
            v-model="value.periodo_inicio"
            update-on="change"
          />
        </div>
        <div class="col-md-6 col-lg-4 mt-3">
          <base-input
            type="date"
            label="End period"
            input-classes="form-control-alternative"
            v-model="value.periodo_fim"
            update-on="change"
          />
        </div>
        <!-- <div class="col-md-6 col-lg-4 mt-3" v-if="!$root.isClient">
          <multiple-select
            multiple
            label="Receivers | Shippers"
            placeholder="select Receiver | Shipper"
            :options="options.recebedores"
            :disabled="loading"
            v-model="value.recebedor_id"
          />
        </div> -->
        <div class="col-md-6 col-lg-4 mt-3">
          <button
            style="margin-top: 32px"
            class="submit w-100 mx-0 position-relative"
            :disabled="loading"
            @click="$emit('search')"
          >
            <i class="fa fa-spinner fa-spin" v-if="loading"></i> Search <i class="fa-solid fa-magnifying-glass position-absolute" style="right: 20px; top: 50%; transform: translateY(-50%);" v-if="!loading"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["value", "loading", "options", "statusOptions", "clientTypes"],
};
</script>

<style>

 .multiselect__tags .multiselect__single  {
  background-color: #ff001f !important;
}
h2 {
  margin-bottom: 0px !important;
}
</style>
